<template>
  <div class="inning-tab">
    <div class="inning-window">
      <ul class="inning-list" :style="styleObj">
        <li v-for="(count, index) in totalInning" :key="index">
          <button type="button" @click.prevent="inningClickFn(count)" :class="activeClass(count)" :disabled="isInningDisabled(count)">{{count}}</button>
        </li>
      </ul>
      <button type="button" @click.prevent="arrowClick('prev')" class="button-inning button-prev" :disabled="isDisabled('prev')">prev</button>
      <button type="button" @click.prevent="arrowClick('next')" class="button-inning button-next" :disabled="isDisabled('next')">next</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InningTab',
    props: {
      selectedInning: {
        type: Number
      },
      nowInning: {
        type: Number
      },
      lastInning: {
        type: Number
      },
      inningClickFn: {
        type: Function
      }
    },
    data () {
      return {
        styleObj: {}
      }
    },
    computed: {
      totalInning () {
        return this.lastInning <= 9 ? 9 : Number(this.lastInning)
      }
    },
    methods: {
      activeClass (inning) {
        if (this.selectedInning === inning) {
          return 'active'
        } else if (this.nowInning >= inning) {
          return 'before'
        } else return ''
      },
      isInningDisabled (inning) {
        return this.nowInning < inning
      },
      arrowClick (arrow) {
        if (arrow === 'next') {
          const num = this.totalInning === 9 ? 36 : 36 * (this.totalInning - 8)
          this.styleObj = {
            width: (36 * this.totalInning) + 'px',
            transform: `translateX(-${num}px)`
          }
        } else {
          this.styleObj = {
            width: (36 * this.totalInning) + 'px',
            transform: 'translateX(0px)'
          }
        }
      },
      isDisabled (arrow) {
        if (arrow === 'next') {
          if (this.styleObj.transform.indexOf('-') > -1) {
            return true
          }
        } else {
          if (this.styleObj.transform === 'translateX(0px)') {
            return true
          }
        }
      },
      init () {
        this.styleObj = {
          width: (36 * this.totalInning) + 'px',
          transform: this.selectedInning > 8 ? `translateX(-${(this.totalInning - 8) * 36}px)` : ''
        }
      }
    },
    created () {
      this.init()
    },
    watch: {
      selectedInning () {
        this.init()
      }
    }
  }
</script>
